import React from 'react';
import { featuredTestimonials } from '../data/testimonials';
const stats: Array<[string, string]> = [['1,500+', 'Functional coaches worldwide'], ['6 + 5', 'Professional volumes & bonus assets'], ['4.9/5', 'Average instructor rating'], ['Daily use', 'Setting the standard in functional fitness']];
export function ProofSection() {
  return <section className="bg-white px-5 py-14" data-id="element-163" data-mp="34yty6u4tk2ab">
      <div className="mx-auto max-w-6xl" data-id="element-164" data-mp="3a0t3wao17baf">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[.22em] text-sage-700" data-id="element-165" data-mp="39zrh58xnl0cv">
          Trusted by functional training professionals
        </p>
        <div className="mt-8 grid grid-cols-2 border border-line sm:grid-cols-4" data-id="element-166" data-mp="3itcwatdqcjmt">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-line px-5 py-7 text-center last:border-r-0 sm:border-b-0" data-id="element-167" data-mp="3nqmqsnfz7lhi">
              <p className="font-display text-4xl font-semibold text-ink-900 sm:text-[2.75rem]" data-id="element-168" data-mp="1l9e5lmkkb04">
                {value}
              </p>
              <p className="mx-auto mt-2 max-w-[16ch] text-[11px] font-medium uppercase tracking-[.14em] text-ink-600" data-id="element-169" data-mp="15lf2wg3pni6e">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-170" data-mp="vrespztknmqt">
          {featuredTestimonials.map(({
          quote,
          name,
          role
        }) => <figure key={name} className="flex flex-col border border-line bg-stone-50 p-7" data-id="element-171" data-mp="1odq3226zd20t">
              <div className="mb-4 text-clay-500" aria-label="5 out of 5 stars" data-id="element-172" data-mp="1jfy26iocy5kh">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-[15px] leading-relaxed text-ink-800" data-id="element-173" data-mp="1emdat9h9s9u9">
                “{quote}”
              </blockquote>
              <figcaption className="mt-auto pt-5 text-sm font-semibold text-ink-900" data-id="element-174" data-mp="2748uuyjwgyxo">
                {name}
                <span className="ml-2 font-normal text-ink-600" data-id="element-175" data-mp="22d8wdov4u8t2">{role}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}